export default __webpack_public_path__ + "static/bathroom_cover-0899853a865af46c5a8cc1217d4249a1.png";